module.exports = __webpack_public_path__ + "omniv2/img/icon-hand-money.a669bcd2.svg";